/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Harden_Output6Inputs */

const en_svc_mvp_sprint_harden_output6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch handoff`)
};

const ar_svc_mvp_sprint_harden_output6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسليم الإطلاق`)
};

const bn_svc_mvp_sprint_harden_output6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লঞ্চ হস্তান্তর`)
};

const de_svc_mvp_sprint_harden_output6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch-Übergabe`)
};

const es_svc_mvp_sprint_harden_output6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega del lanzamiento`)
};

const fr_svc_mvp_sprint_harden_output6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passation du lancement`)
};

const pt_svc_mvp_sprint_harden_output6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega do lançamento`)
};

const zh_svc_mvp_sprint_harden_output6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上线交接`)
};

const tr_svc_mvp_sprint_harden_output6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lansman devri`)
};

const ru_svc_mvp_sprint_harden_output6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Передача запуска`)
};

const pl_svc_mvp_sprint_harden_output6 = /** @type {(inputs: Svc_Mvp_Sprint_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przekazanie startu`)
};

/**
* | output |
* | --- |
* | "Launch handoff" |
*
* @param {Svc_Mvp_Sprint_Harden_Output6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_harden_output6 = /** @type {((inputs?: Svc_Mvp_Sprint_Harden_Output6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Harden_Output6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_harden_output6(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_harden_output6(inputs)
	if (locale === "de") return de_svc_mvp_sprint_harden_output6(inputs)
	if (locale === "es") return es_svc_mvp_sprint_harden_output6(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_harden_output6(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_harden_output6(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_harden_output6(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_harden_output6(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_harden_output6(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_harden_output6(inputs)
	return en_svc_mvp_sprint_harden_output6(inputs)
});
export { svc_mvp_sprint_harden_output6 as "svc_mvp-sprint_HARDEN_output" }